import { useState } from "react"
import { createFileRoute, Link } from "@tanstack/react-router"
import { Send, Trash2 } from "@/components/icons"
import { AppLayout } from "@/components/AppLayout"
import { DesktopPage } from "@/components/desktop/DesktopPage"
import { DesktopPageHeader } from "@/components/desktop/DesktopPageHeader"
import { useIsDesktop } from "@/components/ui/use-mobile"
import { TopBarBackButton } from "@/components/topbar/TopBarBackButton"
import { Card } from "@/components/ui/card"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useCrewDeactivateMe } from "@/lib/hooks/crew/crew.hooks.mutations"
import { useCrewGetMe } from "@/lib/hooks/crew/crew.hooks.queries"
import { useAuth } from "@/hooks/useAuth"

export const Route = createFileRoute("/_auth/profile/help-support")({
  component: RouteComponent,
})

function RouteComponent() {
  const isDesktop = useIsDesktop()
  const { signOut } = useAuth()
  const { data: me } = useCrewGetMe()
  const deactivateMe = useCrewDeactivateMe()
  const [showConfirm, setShowConfirm] = useState(false)
  const isAdmin = me?.isAdmin ?? false

  const handleContactClick = () => {
    window.location.href = "mailto:support@pronteer.com"
  }

  const handleDeactivate = () => {
    deactivateMe.mutate(undefined, {
      onSuccess: () => {
        signOut()
      },
    })
  }

  const body = (
    <>
      <div className="flex flex-col gap-14">
        {/* Contact us */}
        <div className="flex flex-col gap-4">
          <p className="text-sm font-semibold text-content-primary-bold">Contact us</p>
          <Card className="py-2 px-0 border-none">
            <button
              onClick={handleContactClick}
              className="flex gap-3 items-center min-h-9 px-3 py-[7.5px] w-full text-left"
            >
              <Send className="size-5 text-content-primary-bold" />
              <div className="flex-1 flex flex-col min-w-0">
                <p className="text-sm text-content-primary-bold tracking-[0.07px]">
                  support@pronteer.com
                </p>
              </div>
            </button>
          </Card>
        </div>

      </div>

      <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Deactivate Account</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to deactivate your account? This action
              cannot be undone and you will lose access immediately.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDeactivate}
              className="bg-content-negative-bold text-content-primary-inverse hover:bg-content-negative-bold/90"
            >
              {deactivateMe.isPending ? "Deactivating..." : "Deactivate"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )

  if (isDesktop) {
    return (
      <DesktopPage>
        <DesktopPageHeader
          title="Help & Support"
          breadcrumb={
            <span>
              <Link to="/profile" className="hover:underline">
                Profile
              </Link>
              <span className="text-content-primary-subtle"> / Help & Support</span>
            </span>
          }
        />
        {body}
      </DesktopPage>
    )
  }

  return (
    <AppLayout
      topBar={<TopBarBackButton title="Help & Support" />}
      className="bg-transparent pb-20"
    >
      {body}
    </AppLayout>
  )
}
